import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SecondaryButtonComponent from 'components/buttons/secondaryButton/SecondaryButtonComponent';

function SaveForLaterButtonComponent({ onClickSaveForLater, airlineWhitelabel }) {
  return (
    <AnchorContainer onClick={onClickSaveForLater}>
      <Icon icon='share-alt' />
      <Anchor airlineWhitelabel={airlineWhitelabel}>
        <FormattedMessage id={'saveForLater.button'} description={'Save or share'} defaultMessage={'Save or share'} />
      </Anchor>
    </AnchorContainer>
  );
}

export default SaveForLaterButtonComponent;

const AnchorContainer = styled(SecondaryButtonComponent)`
  margin-top: 16px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary.red && theme.colors.primary.red};
  border: ${({ theme }) => theme.colors.primary.red && `1px solid ${theme.colors.primary.red}`};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary.red && theme.colors.primary.red};
    color: ${({ theme }) => theme.colors.primary.red && theme.colors.text.white};
  }
`;

const Anchor = styled.a`
  font-size: 16px;
  font-weight: ${({ airlineWhitelabel }) => (airlineWhitelabel && airlineWhitelabel.isAirBaltic ? 500 : 'bold')};
  text-align: center;
  color: inherit;

  &:hover {
    color: ${({ theme }) => theme.colors.primary.red && theme.colors.text.white};
  }
`;

const Icon = styled(FontAwesomeIcon)`
  font-size: 14px;
  margin-right: 4px;
`;
